import React, { useContext, useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { AuthContext } from './contexts/AuthContext';
import { Router as AuthenticatedRouter } from './pages/authenticated/Router';
import { Router as PublicRouter } from './pages/public/Router';
import { ConfigLoading } from './components/configLoading/ConfigLoading';
import { usePermissions } from './contexts/PermissionsContext';
import { useActiveTenant } from './contexts/ActiveTenantContext';

const AppRouter: React.FC = () => {
  const auth = useContext(AuthContext);

  const { isLoading: isActiveTenantLoading } = useActiveTenant();
  const { isLoading: isPermissionsLoading } = usePermissions();
  const isLoading = auth.loading || (auth.user && (isActiveTenantLoading || isPermissionsLoading));

  // Check for pending invite redirect after successful authentication
  useEffect(() => {
    if (auth.user && !auth.loading) {
      const pendingInviteId = sessionStorage.getItem('pendingInviteId');
      if (pendingInviteId) {
        AuthenticatedRouter.navigate(`/invite/accept/${pendingInviteId}`);
      }
    }
  }, [auth.user, auth.loading]);
  return (
    <ConfigLoading>
      {isLoading ? (
        <></>
      ) : auth.user ? (
        <RouterProvider key="authenticated" router={AuthenticatedRouter} />
      ) : (
        <RouterProvider key="public" router={PublicRouter} />
      )}
    </ConfigLoading>
  );
};

export default AppRouter;
